import { UTILITY_CSS_CLASSES } from "../global/constants";
import Icon from "./Icon";

export const ReloadIcon = ({size=6, customClass='', name='restart'}) => {
    const reloadIconClass = `reload-icon ${UTILITY_CSS_CLASSES.reloadAnimation}`;

    return (
        <div className={`reload-icon-wrapper ${customClass}`}>
            <Icon customClass={reloadIconClass} name={name} size={size} />
        </div>
    )
}

export default ReloadIcon;